import { defineRecipe } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  className: 'ac-link',
  base: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: 'color-mix({colors.halton.blue} 100%, black 10%)',

    transitionProperty: 'color',
    transitionDuration: 'fast',
    transitionTimingFunction: 'ease-in-out',

    _hover: {
      color: 'color-mix({colors.halton.blue} 100%, black 60%)',
    },

    _visited: {
      color: 'color-mix({colors.halton.blue} 100%, black 10%, {colors.halton.red} 40%)',
    },
  },
});
